import axios from './myAxios'
import { stringify } from 'qs'

import { getResource } from './BaseRequests'


export const fetchLogin = ({ username, password }, success, fail) => {

    var data_obj = {
        auth: { action: "login", login: username, password: password },
    }

    // this is funky because of https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
    var data = {
        "params": JSON.stringify(data_obj)
    }

    axios.post('/', stringify(data)).then(response => {
        if (response.data.login.success) {
            return success(response.data.login)
        } else {
            return fail(response.data.login)

        }
    }).catch(err => {
        fail(err)
    })
}

export const fetchLogout = (success, fail) => {
    var data_obj = {
        auth: { action: "logout" },
    }

    // this is funky because of https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
    var data = {
        "params": JSON.stringify(data_obj)
    }

    axios.post('/', stringify(data)).then(() => {
        return success()
    }).catch(err => {
        fail(err)
    })
}


export const fetchCheckLogin = (success) => {
    getResource("check_login", null, false, true)
        .then(response => { 
            success(response.data.is_logged_in) 
        })
}